import React from "react";
import Versiculo from "../components/Versiculo";
import CarruselCreencias from "../components/CarruselCreencias";
import {
  FaCross,
  FaBible,
  FaGlobeAmericas,
  FaHandsHelping,
  FaUsers,
  FaHeart,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FAQ } from "../components/FAQ";
import { Form } from "../components/Form";


export default function Conocenos() {
  return (
    <>
      {/* HERO */}

      <section
        className="text-white d-flex align-items-center hero-conocenos"
        style={{
          minHeight: "120vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,.55), rgba(61,16,66,.70)), url('https://thumbs-us-east-1.myalbum.io/photo/1k0/97ef96af-52da-4a5f-bab9-043da182ba7b.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginTop: "100px",
        }}
      >
        <div className="container text-center">
          <h1 className="display-2 fw-bold titulos-secciones">Conócenos</h1>

          <p className="lead mt-3">
            Formando jóvenes para impactar al Perú y al mundo con el Evangelio.
          </p>
        </div>
      </section>

      {/* QUE ES */}

      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src="https://thumbs-us-east-1.myalbum.io/photo/1k0/2c9f0b49-9861-435b-8f7d-46a4e67f5e29.jpg"
                alt=""
                className="img-fluid rounded-4 shadow-lg"
              />
            </div>

            <div className="col-lg-6">
              <h2 className="fw-bold mb-4" style={{ color: "#3d1042" }}>
                ¿Qué es Teen Missions Perú?
              </h2>

              <p
                style={{
                  lineHeight: "1.5",
                  textAlign: "justify",
                  fontSize: "1.3rem",
                }}
              >
                Somos una extensión del ministerio TEEN MISSIONS INT en florida
                que desarrolla un trabajo desde los años 70. Teen Missions Perú
                viene trabajando como un ministerio interdenominacional en el
                país que sirve a la iglesia local, comprometido con la
                formación, capacitación y movilización de jóvenes con pasión por
                Dios y por las misiones. A través de programas de entrenamiento
                misionero, academias, proyectos evangelisticos, y de
                construcción en el interior del país, como expediciones fuera
                del pais, buscamos preparar una generación que impacte vidas y
                transforme comunidades llevando el evangelio donde Dios los
                llame.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MISION Y VISION */}

      <section
        className="py-5"
        style={{
          background: "#f8f9fa",
        }}
      >
        <div className="container">
          <h2 className="text-center fw-bold mb-5" style={{ color: "#3d1042" }}>
            Nuestra Misión y Visión
          </h2>

          <div className="row g-4">
            <div className="col-md-6">
              <div className="card border-0 shadow h-100 p-4">
                <h4 style={{ color: "#9531a0", fontSize: "1.5rem" }}>Misión</h4>

                <p
                  style={{
                    color: "#040004",
                    fontSize: "1.3rem",
                    textAlign: "justify",
                  }}
                >
                  Inspirar y equipar a la nueva generación para que
                  valientemente proclame la salvación solo en Cristo.
                  <br />
                  <span style={{ color: "#9531a0" }}>
                    <div style={{ textAlign: "center" }}>
                      <Versiculo referencia="1 Pedro 2:9" />
                    </div>
                  </span>
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card border-0 shadow h-100 p-4">
                <h4 style={{ color: "#9531a0", fontSize: "1.5rem" }}>Visión</h4>
                <p
                  style={{
                    color: "#040004",
                    fontSize: "1.3rem",
                    lineHeight: "1.5",
                    maxWidth: "700px",
                    margin: "0 auto",
                    textAlign: "justify",
                  }}
                >
                  Servir a la iglesia como un recurso estratégico para{" "}
                  <span
                    className="fw-bold"
                    style={{
                      color: "#0c010c",
                    }}
                  >
                    Motivar, Entrenar y Movilizar
                  </span>{" "}
                  a la juventud para cumplir la Gran Comisión.
                  <br />
                  <span style={{ color: "#9531a0" }}>
                    <div style={{ textAlign: "center" }}>
                      <Versiculo referencia="Mateo 28:18-20" />
                    </div>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALORES */}

      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-1"
            style={{ color: "#3d1042", fontSize: "2.3rem" }}
          >
            Lo que Creemos
          </h2>   
        </div>
      </section>   
      <CarruselCreencias />
      <section className="py-0">
        <div className="container-fluid px-0">
          <img
            src="https://thumbs-us-east-1.myalbum.io/photo/1k0/6b6b8d25-8144-4762-9d4c-58f4044804fc.jpg"
            alt=""
            className="img-fluid rounded-4 shadow-lg"
          />
        </div>
      </section>

      <section className="py-0">
        <div className="container-fluid px-0">
          <Form />
        </div>
      </section>

      
    </>
  );
}
